import { DEBUG_TRAVEL_LINE_COLORS } from '@/constants.js'

export class Utility {
  constructor() {
    this.api_url = process.env.API_URL + '/'
    this.icon = {
      wheelchair_icon: require('@/assets/icon/ic_wheelchair.svg'),
      no_wheelchair_icon: require('@/assets/icon/ic_wheelchair_no.svg'),
      air_condition_icon: require('@/assets/icon/ic_air_condition.svg'),
      no_air_condition_icon: require('@/assets/icon/ic_air_condition_no.svg'),
      pin_content_icon: require('@/assets/icon/ic_pin_bus_content.png'),
      pin_content_icon_hd: require('@/assets/icon/ic_pin_bus_content_2x.png'),
      pin_direction_icon: require('@/assets/icon/ic_pin_bus_direction.png'),
      pin_direction_icon_hd: require('@/assets/icon/ic_pin_bus_direction_2x.png')
    }
    this.idToColorMapping = {}
    this.colorIndex = 0
    this.travelLineList = []
    this.travelMarkerList = []
    // non-debug: gps popup timestamp is hidden until the vehicle icon is clicked
    // state lives here because popups are rebuilt on every updateGps() call
    this.showGpsTimeStamp = false
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest && e.target.closest('.popup-timestamp-toggle')
      if (!toggle) return
      this.showGpsTimeStamp = !this.showGpsTimeStamp
      const side = toggle.closest('.badge-popup').querySelector('.popup-side')
      if (side) side.classList.toggle('d-none', !this.showGpsTimeStamp)
    }, true)
  }
  updateGps(map, tripItems, { useSnappedLocation = false, markFirstToArrive = false, markNotApproaching = false, drawTravelPath = false, selectedGpsId = null, searchKeyword = '' }) {
    const scope = this
    const isDebug = markFirstToArrive || drawTravelPath

    let gpsPopupActiveId = null
    const oldMarkerList = map.Overlays.list().filter(x => !!x.gpsId)
    map.Overlays.list().forEach(pin => {
      if (pin.gpsId) {
        if (pin.popup().active()) {
          gpsPopupActiveId = pin.gpsId
        }
        map.Overlays.remove(pin)
      }
    })

    for (let i in tripItems) {
      const tripItem = tripItems[i]
      const gpsPin = tripItem.gpsPin
      tripItem.gpsList.forEach(function (item, idx) {
        const gpsTime = (new Date(item.time * 1000)).toLocaleTimeString() // t1
        const receivedTime = (new Date(item.received * 1000)).toLocaleTimeString() // t2
        const createdTime = (new Date(item.created * 1000)).toLocaleTimeString() // t3
        var div = `<div class="badge ${(markFirstToArrive && item.is_first_to_arrive) ? 'first-to-arrive' : ''} ${(markNotApproaching && !item.is_approaching_stop) ? 'not-approaching' : ''}">`
        div += `<img src="${scope.icon.pin_content_icon_hd}" width="65">`
        div += `<img class="badge-direction" src="${scope.icon.pin_direction_icon_hd}" width="65" style="transform: translateX(-50%) translateY(-50%) rotate(${useSnappedLocation ? item.snapped_heading : item.heading}deg);">`
        div += '<div class="badge-content">'
        if (gpsPin.iconUrlHD) {
          div += `<img width="32" src="${scope.api_url + gpsPin.iconUrlHD}">`
        } else if (gpsPin.newName) {
          div += `<div class="badge-name">${gpsPin.name}</div>
          <div class="badge-new-name">${gpsPin.newName}</div>`
        } else {
          div += `<div class="badge-name text-xs">${gpsPin.name}</div>`
        }
        if (drawTravelPath) {
          div += `<div class="badge-debug-id">${item.id}</div>`
        }
        div += '</div></div>'
        //
        const popupTimeStamp = `
          <div class="popup-side ${isDebug || scope.showGpsTimeStamp ? '' : 'd-none'}">
            time: ${gpsTime}<br>
            received: ${receivedTime}<br>
            created: ${createdTime}
          </div>
        `
        const popupHtml = `
          <div class="badge-popup">
            <div class="popup-top">
              <span>${gpsPin.name}</span>
              ${gpsPin.newName ? `<span class="route-new-name">${gpsPin.newName}</span>` : ''}
            </div>
            <div class="popup-bottom">
              <img width="14" src="${scope.api_url}${tripItem.iconUrlHD}" ${isDebug ? '' : 'class="popup-timestamp-toggle" style="cursor: pointer;"'}>
              <span class="ml-1 mr-1">${item.id}</span>
              <img width="16" src="${tripItem.wheelchairAccessible ? scope.icon.wheelchair_icon : scope.icon.no_wheelchair_icon}">
              <img width="16" class="ml-1" src="${tripItem.airCondition ? scope.icon.air_condition_icon : scope.icon.no_air_condition_icon}">
            </div>
            <div class="popup-hr" style="border-color: #${tripItem.routeColor || tripItem.color}"></div>
            ${popupTimeStamp}
          </div>
        `

        // draw travel path
        if (drawTravelPath) {
          const oldMarker = oldMarkerList.find(x => x.gpsId === item.id)
          if (oldMarker) {
            var locationList = [
              oldMarker.location(),
              item
            ];
            let lineColor = scope.idToColorMapping[item.id]
            if (!lineColor) {
              lineColor = DEBUG_TRAVEL_LINE_COLORS[scope.colorIndex % DEBUG_TRAVEL_LINE_COLORS.length]
              scope.idToColorMapping[item.id] = lineColor
              scope.colorIndex++
            }
            item.debugLineColor = lineColor
            const travelLineOptions = {
              detail: item.id,
              lineWidth: 4,
              lineColor: lineColor,
              lineStyle: longdo.LineStyle.Dashed,
              weight: longdo.OverlayWeight.Top
            }
            const travelLine = new longdo.Polyline(
              locationList,
              travelLineOptions
            );
            travelLine.travelLineGpsId = item.id
            scope.travelLineList.push(travelLine)
            // travel label
            const travelMarkerOptions = {
              icon: {
                html: `<div class="travel-line-label">${gpsTime}</div>`,
              },
              weight: longdo.OverlayWeight.Top
            }
            const travelMarker = new longdo.Marker(
              item,
              travelMarkerOptions
            )
            scope.travelMarkerList.push(travelMarker)
          }
        }

        // create marker
        const markerOptions = {
          icon: {
            html: div,
          },
          popup: {
            html: popupHtml,
          }
        }
        const markerLocation = {
          lat: useSnappedLocation ? item.snapped_lat : item.lat,
          lon: useSnappedLocation ? item.snapped_lon : item.lon
        }
        if (!!selectedGpsId && selectedGpsId !== item.id) {
          markerOptions.visibleRange = { min: 20, max: 20 } // hide marker if not selected
        }
        if (searchKeyword && !item.id.includes(searchKeyword)) {
          markerOptions.visibleRange = { min: 20, max: 20 } // hide marker if not selected
        }
        const marker = new longdo.Marker(
          markerLocation,
          markerOptions
        )
        marker.gpsId = item.id
        map.Overlays.add(marker)
        if (selectedGpsId && selectedGpsId === item.id) {
          map.location(markerLocation, true)
        }
        if (marker.gpsId === gpsPopupActiveId) {
          marker.pop()
          gpsPopupActiveId = null
        }
      })
    }
    // update travel path visibility
    if (drawTravelPath) {
      this.travelLineList.forEach(function (line, idx) {
        if (!selectedGpsId) { // add all
          if (!line.isOnMap) {
            map.Overlays.add(line)
            map.Overlays.add(scope.travelMarkerList[idx])
            line.isOnMap = true
          }
        } else {
          if (line.travelLineGpsId === selectedGpsId) {
            if (!line.isOnMap) {
              map.Overlays.add(line)
              map.Overlays.add(scope.travelMarkerList[idx])
              line.isOnMap = true
            }
          } else {
            if (line.isOnMap) {
              map.Overlays.remove(line)
              map.Overlays.remove(scope.travelMarkerList[idx])
              line.isOnMap = false
            }
          }
        }
      })
    }
  }
  convertMeterToDistance(meter, i18n) {
    var locale = i18n.locale

    if (isNaN(meter) || meter == 0) {
      return ''
    } else if (meter < 1000) {
      return (meter).toFixed(0) + ' ' + i18n.messages[locale].message.meter
    } else {
      return (meter * 0.001).toFixed(1) + ' ' + i18n.messages[locale].message.km
    }
  }
  convertSecondToTime(second, i18n, html = false) {
    var locale = i18n.locale
    if (isNaN(second) || second == 0) {
      return ''
    }

    if (second < 60) {
      second = 60
    }

    var onehr = (60 * 60)
    if (second < onehr) {
      var result = Math.ceil(second / 60)
      if (result > 1) {
        result += ' ' + `${html ? '<span class="font-weight-medium">' : ''}${i18n.messages[locale].message.minutes}${html ? '</span>' : ''}`
      } else {
        result += ' ' + `${html ? '<span class="font-weight-medium">' : ''}${i18n.messages[locale].message.minute}${html ? '</span>' : ''}`
      }

      return result
    } else {
      var hrs = Math.floor(second / onehr)
      var mins = Math.floor((second % onehr) / 60)

      if (hrs > 1) {
        hrs += ' ' + `${html ? '<span class="font-weight-medium">' : ''}${i18n.messages[locale].message.hours}${html ? '</span>' : ''}`
      } else {
        hrs += ' ' + `${html ? '<span class="font-weight-medium">' : ''}${i18n.messages[locale].message.hour}${html ? '</span>' : ''}`
      }

      if (mins > 1) {
        mins += ' ' + `${html ? '<span class="font-weight-medium">' : ''}${i18n.messages[locale].message.minutes}${html ? '</span>' : ''}`
      } else if (mins == 1) {
        mins += ' ' + `${html ? '<span class="font-weight-medium">' : ''}${i18n.messages[locale].message.minute}${html ? '</span>' : ''}`
      } else {
        mins = ''
      }

      return hrs + ' ' + mins
    }
  }

  shareUrl(url, i18n) {
    if (navigator.share) {
      navigator.share({
        url: url
      })
    } else {
      this.copyToClipboard(url, i18n)
    }
  }

  async copyToClipboard(text, i18n) {
    var locale = i18n.locale
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text)
        alert(i18n.messages[locale].message.link_copied)
      } catch (err) {
        alert('Failed to copy: ', err.message)
        console.warn({ err })
      }
    } else {
      var textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      alert(i18n.messages[locale].message.link_copied)
    }
  }
}
